import { FileClient, RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B080020FindRequest = { shukashijiYmd: string } & Partial<{
  shijikaisu: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B080020FindResponse = {
  shukashijiYmd: string;
  shijikaisu: string;
  batchNo: string;
  batchNm: string;
  tenposu: string;
  shohinsu: string;
  denpyomaisu: string;
  denpyogyosu: string;
  ppshijisu: string;
  netsukeshijisu: string;
  setshohinsu: string;
  shukajokyo: string;
  sagyohako: string;
};

export const B080020Find = (props: B080020FindRequest) => {
  return RestClient.get<PageableResponse<B080020FindResponse[]>>(
    "b080020/find",
    {
      params: props,
    }
  );
};

export type B080020PrintDetailRequest = {
  shukashijiYmd: string;
  shijikaisu: string;
  batchNo: string;
  shukajokyo: number;
  version: string;
};

export type B080020PrintRequest = Partial<{
  b080020PrintDetailRequestlist: B080020PrintDetailRequest[];
}>;

//印刷処理
export const B080020Print = (props: B080020PrintRequest) => {
  return FileClient.put("b080020/print", props);
};
